import { GARDEN_CDN_PATH } from '../../garden-constants';

export type BannerStructure = {
  title: string;
  description: string;
  imgSrc: string;
  link: {
    href: string;
    title: string;
  };
};

export const BANNER_LIST_FULL: BannerStructure[] = [
  {
    title: 'Насосы для дома и\u00A0дачи',
    description: 'Виды и свойства',
    imgSrc: `${GARDEN_CDN_PATH}/banners/pumps-d.jpg/pumps-d.jpg`,
    link: {
      href: '/promo/vybor-nasosa-dlya-doma-i-dachi/',
      title: 'Насосы для дома и дачи: виды и свойства',
    },
  },
  {
    title: 'Заборы под заказ',
    description: 'Для участков любой площади',
    imgSrc: `${GARDEN_CDN_PATH}/banners/fences-spring-d.jpg/fences-spring-d.jpg`,
    link: {
      href: '/uslugi/gotovye-resheniya-pod-klyuch/zabory-na-zakaz/',
      title: 'Заборы на заказ',
    },
  },
];

export const BANNER_LIST_SINGLE: BannerStructure[] = [
  {
    title: 'Насосы для дома и\u00A0дачи',
    description: 'Виды и свойства',
    imgSrc: `${GARDEN_CDN_PATH}/banners/pumps-2.jpg/pumps-2.jpg`,
    link: {
      href: '/promo/vybor-nasosa-dlya-doma-i-dachi/',
      title: 'Насосы для дома и дачи: виды и свойства',
    },
  },
];
